import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { UserManagement } from '../Api/UserManagement';
import { Toast } from '../hooks/useToast';


export const fetchUserManagementThunk = createAsyncThunk(
    'userManangement/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await UserManagement.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const deleteUserManagementThunk = createAsyncThunk(
    'userManangement/delete',
    async (slug, { getState }) => {
        try {
            Toast('Deleting user', 'loading', true)
            const { api_token } = getState().profile.data;
            const response = await UserManagement.delete(slug, api_token);
            Toast('User deleted successfully', 'success', false)
            return slug
        } catch (err) {
            Toast(err.message, 'error', false)
            return Promise.reject(err.message);
        }
    }
)

export const updateUserManagementThunk = createAsyncThunk(
    'userManangement/update',
    async (data, { getState, dispatch }) => {
        try {
            const { api_token } = getState().profile.data;
            dispatch(updateStatus(data));
            const response = await UserManagement.update({ data, api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err.message);
        }
    }
)

const initialState = {
    status: "pending",
    data: [],
}

export const userManagementSlice = createSlice({
    name: 'userManagement',
    initialState,
    reducers: {
        resetState: () => {
            return initialState
        },
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        updateStatus: (state, actions) => {
            return {
                ...state,
                data: [
                    ...state.data.map(item => {
                        const { slug, online_status } = actions.payload;
                        if (item.slug === slug) {
                            return {
                                ...item,
                                online_status,
                            }
                        }
                        else {
                            return item;
                        }
                    })
                ]
            }
        }
    },
    extraReducers: {
        [fetchUserManagementThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchUserManagementThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [updateUserManagementThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [updateUserManagementThunk.pending]: (state, action) => {
            state.status = "success"
        },
        [updateUserManagementThunk.rejected]: (state, action) => {
            state.status = "loading"
        },
        [deleteUserManagementThunk.fulfilled]: (state, action) => {
            const slug = action.payload;
            state.data = state.data.filter(item => item.slug !== slug)
        },


    }

})


// Action creators are generated for each case reducer function
export const { setStatus, updateStatus, resetState } = userManagementSlice.actions

export default userManagementSlice.reducer